const getDefaultState = () => {
    return {
        currentStep: 3,
        steps: [
            {
                index: 1,
                name: 'Schimbare parolă',
                icon: 'fas fa-key',
                payload: {
                    password: '',
                    password_confirmation: ''
                },
                isLoading: false
            },
            {
                index: 2,
                name: 'Detalii profil',
                icon: 'fas fa-user',
                payload: {
                    first_name: '',
                    last_name: '',
                    dob: ''
                },
                isLoading: false
            },
            {
                index: 3,
                name: 'Imagine și videoclip profil',
                icon: 'fas fa-images',
                payload: {
                    image_url: null,
                    video_url: null
                },
                isLoading: false
            },
            {
                index: 4,
                name: 'Titlu si pret de baza',
                icon: 'fas fa-coins',
                payload: {
                    title: '',
                    base_price: 0,
                    minute_base_price: 0,
                    min_services: 1
                },
                isLoading: false
            },
            {
                index: 5,
                name: 'Descriere profil',
                icon: 'fas fa-info-circle',
                payload: {
                    selectedIndex: 0,
                    descriptions: [
                        {
                            id: 1,
                            name: 'Despre mine',
                            active: true,
                            value: ''
                        },
                        {
                            id: 2,
                            name: 'Servicii oferite',
                            active: false,
                            value: ''
                        },
                        {
                            id: 3,
                            name: 'Beneficii',
                            active: false,
                            value: ''
                        }
                    ]
                },
                isLoading: false
            },
            {
                index: 6,
                name: 'Disponibilitate',
                icon: 'fas fa-clock',
                payload: {
                    appointments: true,
                    anytimeServices: true,
                    timetable: {}
                },
                isLoading: false
            }
        ],
        countries: null,
        defaultCountry: ''
    }
}
// initial state
const state = getDefaultState();

export default state;
